import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
export default function isZipFile(file) {
  return file.type.includes('application/zip') || file.name.includes('.zip');
}